import getInputs from "./getInputs";

const getFormInitialValues = (fields) => {
    const initialValues = {};
    const inputs = getInputs(fields);
    inputs?.forEach((input) => {
        if (!initialValues[input?.name]) {
            initialValues[input?.name] = input?.value || "";
        }
    });
    return initialValues;
};

export default getFormInitialValues;
